import { NgModule } from '@angular/core';
import { AccessDeniedComponent } from './components/access-denied/access-denied.component';
import { PageNotFoundComponent } from './components/page-not-found/page-not-found.component';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { ProfileBarComponent } from './components/profile-bar/profile-bar.component';
import { RegistrationApprovalPromptComponent } from './components/registration-approval-prompt/registration-approval-prompt.component';
import { WorkshopRegistrationRequestCardComponent } from './components/workshop-registration-request-card/workshop-registration-request-card.component';
import { WorkshopRegistrationRequestRowCardComponent } from './components/workshop-registration-request-row-card/workshop-registration-request-row-card.component';
import { WorkshopRowCardComponent } from './components/workshop-row-card/workshop-row-card.component';
import { MyUpcomingWorkshopListComponent } from './components/my-upcoming-workshop-list/my-upcoming-workshop-list.component';
import {
  DxCheckBoxModule,
  DxPopupModule,
  DxSelectBoxModule,
  DxTabPanelModule,
  DxTextAreaModule,
} from 'devextreme-angular';
import { WorkshopCardComponent } from '../features/workshop/components/workshop-card/workshop-card.component';
import { TranslateModule } from '@ngx-translate/core';
import { WorkshopRegisterComponent } from '../features/workshop/components/workshop-register/workshop-register.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { DxoLoadingIndicatorModule } from 'devextreme-angular/ui/nested';
import { PastWorkshopCardComponent } from './components/past-workshop-card/past-workshop-card.component';
import { ArabicNumberDirective } from './directives/arabic-num-converter.directive';
import { ClickOutsideDirective } from './directives/click-outside.directive';
import { DateToJalaliPipe } from './pipes/date-to-jalali.pipe';
import { StringToDatePipe } from './pipes/string-to-date.pipe';
import { ExtractHtmlTextPipe } from './pipes/extract-html-text.pipe';
import { SafeHtmlPipe } from './pipes/safe-html.pipe';
import { PersianTimePipe } from './pipes/persian-time.pipe';
import { NgIconsModule, provideIcons } from '@ng-icons/core';
import {
  lucideUser,
  lucideCalendar,
  lucideLayers,
  lucideMapPin,
  lucideUserPlus,
  lucideHourglass,
  lucideBan,
  lucideUserCheck,
  lucidePlus,
  lucideClock,
  lucideUserCircle,
  lucideFileText,
  lucideLoader2,
  lucidePaperclip,
  lucideSquare,
  lucideCheck,
} from '@ng-icons/lucide';
import { EWorkshopCardComponent } from '../features/e-workshop/components/e-workshop-card/e-workshop-card.component';
import { AfraTabItemComponent } from './components/tab-group/tab-item.component/tab-item.component';
import { AfraTabPanelComponent } from './components/tab-group/tab-panel.component/tab-panel.component';
import { SharedWorkshopCardComponent } from './components/shared-workshop-card/shared-workshop-card.component';
import { AfraImageComponent } from './components/afra-image/afra-image.component';
import { ButtonLabel, ButtonModule } from 'primeng/button';

@NgModule({
  declarations: [
    AccessDeniedComponent,
    PageNotFoundComponent,
    ProfileBarComponent,
    WorkshopRegistrationRequestRowCardComponent,
    MyUpcomingWorkshopListComponent,
    WorkshopRegisterComponent,
    ArabicNumberDirective,
    ClickOutsideDirective,
    DateToJalaliPipe,
    StringToDatePipe,
    ExtractHtmlTextPipe,
    SafeHtmlPipe,
  ],
  imports: [
    CommonModule,
    RouterModule,
    SharedWorkshopCardComponent,
    AfraImageComponent,
    TranslateModule,
    FormsModule,
    ReactiveFormsModule,
    RouterModule,
    DxTabPanelModule,
    AfraTabItemComponent,
    AfraTabPanelComponent,
    DxPopupModule,
    DxSelectBoxModule,
    DxTextAreaModule,
    DxCheckBoxModule,
    DxoLoadingIndicatorModule,
    NgIconsModule,
    WorkshopRegistrationRequestCardComponent,
    WorkshopRowCardComponent,
    EWorkshopCardComponent,
    WorkshopCardComponent,
    PastWorkshopCardComponent,
    RegistrationApprovalPromptComponent,
    ButtonModule,
  ],
  providers: [
    provideIcons({
      lucideUser,
      lucideCalendar,
      lucideLayers,
      lucideMapPin,
      lucideUserPlus,
      lucideHourglass,
      lucideBan,
      lucideUserCheck,
      lucidePlus,
      lucideClock,
      lucideCheck,
      lucideUserCircle,
      lucideFileText,
      lucideLoader2,
      lucidePaperclip,
      lucideSquare,
    }),
  ],
  exports: [
    AccessDeniedComponent,
    PageNotFoundComponent,
    ProfileBarComponent,
    WorkshopRegistrationRequestRowCardComponent,
    WorkshopRegistrationRequestCardComponent,
    WorkshopRowCardComponent,
    EWorkshopCardComponent,
    WorkshopCardComponent,
    PastWorkshopCardComponent,
    MyUpcomingWorkshopListComponent,
    WorkshopRegisterComponent,
    ArabicNumberDirective,
    ClickOutsideDirective,
    DateToJalaliPipe,
    StringToDatePipe,
    ExtractHtmlTextPipe,
    SafeHtmlPipe,
    AfraImageComponent,
  ],
})
export class SharedModule {}
